import logo from './img/logo.svg';

export const images = [
    logo
];